import { type ReactElement } from 'react'
import { type MaterialSymbolType, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

export type VisibilityFoldVariant = 'hidden' | 'restrictedSelected' | 'restricted'

export type VisibilityState = {
  color: string
  icon: MaterialSymbolType
  label: string
}

export const VISIBILITY_STATES: Record<VisibilityFoldVariant, VisibilityState> = {
  restrictedSelected: {
    color: 'var(--color-blue-600)',
    icon: 'shield',
    label: 'Restricted and currently selected',
  },
  restricted: { color: '#6c757d', icon: 'shield', label: 'Restricted' },
  hidden: { color: 'var(--color-rose-400)', icon: 'lock', label: 'Not visible from the selected team' },
}

type FoldStateInput = {
  isHidden: boolean
  isRestricted: boolean
  isSelected: boolean
}

export const toVisibilityFoldVariant = ({
  isHidden,
  isRestricted,
  isSelected,
}: FoldStateInput): VisibilityFoldVariant | undefined => {
  if (isHidden) return 'hidden'
  if (!isRestricted) return undefined
  if (isSelected) return 'restrictedSelected'
  return 'restricted'
}

const FOLD_SIZE = 30
const GLYPH_SIZE = 13

export const VisibilityCornerFold = ({ variant }: { variant: VisibilityFoldVariant }): ReactElement => {
  const { t } = useTranslation()
  const { color, icon, label } = VISIBILITY_STATES[variant]

  return (
    <div aria-label={t(label)} className='pointer-events-none absolute inset-0 overflow-hidden rounded-md' role='img'>
      <div
        className='h-0 w-0'
        style={{
          borderTop: `${FOLD_SIZE}px solid ${color}`,
          borderRight: `${FOLD_SIZE}px solid transparent`,
        }}
      />
      <MaterialSymbolIcon
        filled
        className='absolute top-[3px] left-[3px]'
        color='#ffffff'
        icon={icon}
        size={GLYPH_SIZE}
      />
    </div>
  )
}
